import React, { Component } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Dimmer,
  Loader
} from "semantic-ui-react";

import { Link, Redirect } from "react-router-dom";
import fire from "../../config/config";

class SignupForm extends Component {
  state = {
    email: "",
    password: "",
    FullName: "",
    errMsg: null,
    signedUp: false,
    loading: false
  };

  signup(e) {
    this.setState({ loading: true }); //set the loading
    const { email, password, FullName } = this.state;
    const date = new Date().getTime();
    e.preventDefault();

    fire
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(
        user => {
          fire
            .database()
            .ref("users")
            .push({
              name: FullName,
              date: date,
              email: email,
              activated: false
            })
            .then(
              () => {
                this.setState({ signedUp: true });
              },
              err => {
                this.setState({ errMsg: err.message, loading: false });
              }
            );
        },
        err => {
          this.setState({ errMsg: err.message, loading: false });
        }
      );
  }

  render() {
    const { errMsg, signedUp, loading } = this.state;

    if (signedUp) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <div className="SignupForm">
        {/*
          Heads up! The styles below are necessary for the correct render of this example.
          You can do same with CSS, the main idea is that all the elements up to the `Grid`
          below must have a height of 100%.
        */}
        <style>{`
          body > div,
          body > div > div,
          body > div > div > div.login-form {
            height: 100%;
          }
        `}</style>
        <Grid
          textAlign="center"
          style={{ height: "100%" }}
          verticalAlign="middle"
        >
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h2" color="yellow" textAlign="center">
              Create Account
            </Header>
            <Form size="large" onSubmit={e => this.signup(e)}>
              <Segment stacked>
                <Form.Input
                  required
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="FullName"
                  onChange={(e, fullname) =>
                    this.setState({ FullName: fullname.value })
                  }
                />
                <Form.Input
                  required
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="E-mail address"
                  onChange={(e, email) => this.setState({ email: email.value })}
                />
                <Form.Input
                  required
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  type="password"
                  onChange={(e, password) =>
                    this.setState({ password: password.value })
                  }
                />
                <Form.Input
                  required
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  type="password"
                />

                <Button color="yellow" fluid size="large">
                  Signup
                </Button>
                {loading ? (
                  <Dimmer active inverted>
                    <Loader size="large">Loading</Loader>
                  </Dimmer>
                ) : null}
              </Segment>
            </Form>
            {errMsg ? <Message>{errMsg}</Message> : errMsg}
            <Message>
              Already have account? <Link to="/Login">Login</Link> or go back
              <Link to="/"> home</Link>
            </Message>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default SignupForm;



// WEBPACK FOOTER //
// ./src/views/LoginAndSignup/SignupForm.js